// Angular modules
import { Component }            from '@angular/core';

// Ionic modules
import { GoogleAnalytics }      from '@ionic-native/google-analytics';
import { NavController }        from 'ionic-angular';
import { NavParams }            from 'ionic-angular';
import { LoadingController }    from 'ionic-angular';
import { ToastController }      from 'ionic-angular';
import { MenuController }       from 'ionic-angular';
import { Platform }             from 'ionic-angular';

// External modules
import { ApplicationService }   from '../../shared/providers/application-service';
import { GascomsuptionPage }    from '../gascomsuption/gascomsuption';
import { GasmixturesPage }      from '../gasmixtures/gasmixtures';
import { GasselectorPhonePage } from '../gasselector-phone/gasselector-phone';
import { GasselectorPage }      from '../gasselector/gasselector';
import { KeyPointsPage }        from '../key-points/key-points';
import { TranslateService }     from '@ngx-translate/core';

// Helpers
import { StorageHelper }        from '../../shared/helpers/storage.helper';

@Component({
  selector:    'page-home-menu',
  templateUrl: 'home-menu.html'
})

export class HomeMenuPage
{
  selectedItem  : any;
  items         : Array<{title: string, page: any, icon: string, background: string, overlay: string, visible: boolean}>;
  cheatIsActive : boolean = false;
  tapCounter    : number = 0;
  gasselector   : string = 'Gas selector';
  consumption   : string = 'Gas Consumption calculator';
  keypoints     : string = 'Key points about MAP';
  mixtures      : string = 'Gas mixtures from competitions';

  constructor(public navCtrl     : NavController,
              public navParams   : NavParams,
              public loadingCtrl : LoadingController,
              public toastCtrl   : ToastController,
              public menuCtrl    : MenuController,
              public platform    : Platform,
              public translate   : TranslateService,
              public applicationService : ApplicationService,
              private analytics  : GoogleAnalytics)
  {
    this.getSelectedLang();
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Home menu ");
  }

  async getSelectedLang()
  {
    try
    {
      const selectedLanguage = await this.applicationService.getSelectedLanguage();
      this.translate.use(selectedLanguage);
      this.initTranslations();
      console.info("[Function] getSelectedLang ->  App was init with : " + selectedLanguage);
    } catch (error)
    {
      this.translate.use('en-GB');
      this.initTranslations();
      console.error("[Function] getSelectedLang -> " + error);
    };
  }

  initTranslations()
  {
    this.translate.get('CONSUMPTION_CALCULATOR').subscribe(
      value => {
        this.consumption = value;
      })

    this.translate.get('KEY_POINTS_ABOUT_MAP').subscribe(
      value => {
        this.keypoints = value;
      })
    this.translate.get('GASSELECTOR').subscribe(
      value => {
        this.gasselector = value;
      })
    this.translate.get('MIXTURES_FROM_COMPETITIONS').subscribe(
      value => {
        this.mixtures = value;
      })
    this.initData();
  }

  initData()
  {
    this.selectedItem = this.navParams.get('item');
    this.items        = [];
    let tablet = this.platform.is('tablet') || this.platform.is('core');

    this.items.push(
    {
      title:      this.gasselector,
      page:       tablet ? GasselectorPage : GasselectorPhonePage,
      icon:       'assets/gasselector_white_icn.png',
      background: 'assets/gasselector_bg.png',
      overlay:    'assets/menu_overlay_1.png',
      visible:    true
    });
    this.items.push(
    {
      title:      this.consumption,
      page:       GascomsuptionPage,
      icon:       'assets/consuption_white_icn.png',
      background: 'assets/consuption_bg.png',
      overlay:    'assets/menu_overlay_2.png',
      visible:    true
    });
    this.items.push(
    {
      title:      this.keypoints,
      page:       KeyPointsPage,
      icon:       'assets/mixtures_white_icn.png',
      background: 'assets/mixtures_bg.png',
      overlay:    'assets/menu_overlay_2.png',
      visible:    true
    });
    if (this.cheatIsActive == true)
    {
      console.log("Showing Cheat page", this.cheatIsActive)
      this.items.push(
      {
        title:      this.mixtures,
        page:       GasmixturesPage,
        icon:       'assets/gasMixture.png',
        background: 'assets/mixtures_bg.png',
        overlay:    'assets/menu_overlay_3.png',
        visible:    true
      });
    }
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  pressEvent(e)
  {
    this.tapCounter++;

    if(this.tapCounter == 3)
    {
      this.setCheatMode();
    }
  }

  setCheatMode()
  {
    const user = StorageHelper.getUser();
    if (!user.CanSeeCompetitor)
      return;
    if(this.cheatIsActive == true)
      this.cheatIsActive = false
    else
      this.cheatIsActive = true

    StorageHelper.setCheat(this.cheatIsActive);
    console.info("[Function] setCheatMode -> cheat state is " + this.cheatIsActive);
    this.initData();
  }

  itemTapped(_, item)
  {
    if(this.cheatIsActive == true)
    {
      this.setCheatMode();
      this.tapCounter = 0;
    }
    this.navCtrl.push(item.page, {}, {animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home-menu/home-menu.ts